import LegalShell from "@/pages/LegalShell";
import { Mail, Clock, Shield } from "lucide-react";

export default function Contact() {
  return (
    <LegalShell title="Contact Us" effective="1 February 2026">
      <p>
        Have a question about your account, payment, a clinical protocol, or want to send feedback? We'd love to
        hear from you.
      </p>

      <div className="not-prose mt-8 space-y-4">
        <a
          href="mailto:drmonashroff@gmail.com"
          className="flex items-start gap-4 border border-slate-200 bg-white rounded-md p-5 hover:border-blue-900 transition-colors"
          data-testid="contact-email-link"
        >
          <Mail className="h-6 w-6 text-blue-900 shrink-0 mt-0.5" strokeWidth={1.75} />
          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Email</div>
            <div className="mt-0.5 font-mono text-lg font-semibold text-slate-900">drmonashroff@gmail.com</div>
            <div className="mt-1 text-sm text-slate-600">Fastest route for support, refunds, feedback and business queries.</div>
          </div>
        </a>

        <div className="flex items-start gap-4 border border-slate-200 bg-white rounded-md p-5">
          <Clock className="h-6 w-6 text-blue-900 shrink-0 mt-0.5" strokeWidth={1.75} />
          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Response time</div>
            <div className="mt-0.5 text-sm text-slate-700">
              We respond within <strong>2 working days</strong>. Refund requests are typically completed within
              5–7 working days through Razorpay.
            </div>
          </div>
        </div>

        <div className="flex items-start gap-4 border border-slate-200 bg-white rounded-md p-5">
          <Shield className="h-6 w-6 text-blue-900 shrink-0 mt-0.5" strokeWidth={1.75} />
          <div>
            <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Grievance Officer (IT Rules 2011)</div>
            <div className="mt-0.5 text-sm text-slate-700">
              <strong>Dr. Mona Shroff, MD</strong> —
              <a href="mailto:drmonashroff@gmail.com" className="ml-1">drmonashroff@gmail.com</a>
            </div>
            <div className="mt-1 text-xs text-slate-500">
              Grievances are acknowledged within 48 hours and resolved within 30 days.
            </div>
          </div>
        </div>
      </div>

      <h2>Operator information</h2>
      <p>
        RIF Master is an independent clinical decision-support product operated by <strong>Dr. Mona Shroff, MD</strong>.
        For KYC / compliance queries related to Razorpay, please include your registered email and payment ID in the
        first message so we can look it up quickly.
      </p>

      <h2>What to include for faster support</h2>
      <ul>
        <li>Your registered email address</li>
        <li>Razorpay payment ID or UPI transaction reference (for payment issues)</li>
        <li>The URL where you saw the issue and a short description of what happened</li>
        <li>Screenshots if a UI element misbehaved</li>
      </ul>

      <p>
        For clinical questions about a specific patient case — please <strong>do not include patient identifying
        information</strong>. Use case codes or initials as you already do inside the app.
      </p>
    </LegalShell>
  );
}
